(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[985],{

/***/ 365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(1445)('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(3454);
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(4805);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),

/***/ 4805:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(7824);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 7824:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 3944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography_Brand_Brand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2737);
/* harmony import */ var _Footer_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3642);
/* harmony import */ var _Footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Footer_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _carbon_icons_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6817);
/* harmony import */ var _carbon_icons_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1657);






const Footer = (param)=>{
    let { hideSocialIcons , hideBackground  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        className: hideBackground ? "".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footerContainer), " ").concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().hideBackground)) : (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footerContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center items-center mt-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography_Brand_Brand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    styles: {
                        fontSize: "32px"
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-center gap-6 items-center mt-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        className: "flex items-center gap-2 main !underline !underline-offset-4",
                        href: "https://discord.gg/yMzFzVUPDf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_carbon_icons_react__WEBPACK_IMPORTED_MODULE_5__/* .LogoDiscord */ .nq, {
                                size: 24
                            }),
                            "Discord"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        className: "flex items-center gap-2 main !underline !underline-offset-4",
                        href: "mailto:info@skingenerator.io",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_carbon_icons_react__WEBPACK_IMPORTED_MODULE_6__/* .SendAltFilled */ .K5, {
                                size: 24
                            }),
                            "Contact Us"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-4 w-full text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex justify-center items-center gap-6 mb-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            className: "main !underline !underline-offset-4",
                            href: "/terms",
                            children: "Terms of Service"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-gray-600",
                            children: "•"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            className: "main !underline !underline-offset-4",
                            href: "/acceptable-use-policy",
                            children: "Acceptable Use Policy"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-gray-600",
                            children: "•"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            className: "main !underline !underline-offset-4",
                            href: "/privacy-policy",
                            children: "Privacy Policy"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-gray-600",
                            children: "•"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            className: "main !underline !underline-offset-4",
                            href: "/cookie-policy",
                            children: "Cookie Policy"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "signature flex white w-full justify-center mt-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "https://www.monadical.com",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "Made with ♥️ by Monadical"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 9416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3856);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Loader_module_scss__WEBPACK_IMPORTED_MODULE_1__);


const Loader = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_Loader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loaderContainer), " ").concat(props.primary && (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().primary)),
        style: props.styles,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                className: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loader),
                width: props.width || 50,
                height: props.height || 50,
                color: props.color || "#8FCA5C",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 200 200",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                                id: "spinner-secondHalf",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "30%",
                                        stopOpacity: "0",
                                        stopColor: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "100%",
                                        stopOpacity: "0.5",
                                        stopColor: "currentColor"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                                id: "spinner-firstHalf",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "0%",
                                        stopOpacity: "1",
                                        stopColor: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "100%",
                                        stopOpacity: "0.5",
                                        stopColor: "currentColor"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        strokeWidth: "10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                stroke: "url(#spinner-secondHalf)",
                                d: "M 4 100 A 96 96 0 0 1 196 100"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                stroke: "url(#spinner-firstHalf)",
                                d: "M 196 100 A 96 96 0 0 1 4 100"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                stroke: "currentColor",
                                strokeLinecap: "round",
                                d: "M 4 100 A 96 96 0 0 1 4 98"
                            })
                        ]
                    })
                ]
            }),
            props.message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "base-1 ".concat(props.fontColor, " ").concat((_Loader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loaderText)),
                children: props.message
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 2737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Brand_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4103);
/* harmony import */ var _Brand_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Brand_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const Brand = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
        onClick: props.onClick,
        className: "brand ".concat((_Brand_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[props.variant || "default"]),
        style: props.styles,
        children: "Minecraft Skin Generator"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Brand);


/***/ }),

/***/ 7272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Loaders_LoaderCircle_Loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9416);
/* harmony import */ var _utils_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4697);



const ButtonPushable = (param)=>{
    let { size ="md" , children , onClick , disabled , loading , type ="button" , className  } = param;
    const isDisabled = disabled || loading;
    const isLarge = size === "lg";
    const frontClasses = isLarge ? "px-8 py-12 text-white -translate-y-6 group-hover:-translate-y-2 group-active:-translate-y-0.5" : "px-6 py-3 text-[#242C36] -translate-y-[0.4rem] group-hover:-translate-y-[0.5rem] group-active:-translate-y-[2px]";
    const transitionClasses = isLarge ? [
        "transition-transform duration-[900ms] [transition-timing-function:cubic-bezier(0.25,0.8,0.25,1)]",
        "group-hover:duration-[450ms] group-hover:[transition-timing-function:cubic-bezier(0.25,0.8,0.25,1)]",
        "group-active:duration-[34ms]"
    ] : [
        "transition-transform duration-[600ms] [transition-timing-function:cubic-bezier(0.3,0.7,0.4,1)]",
        "group-hover:duration-[250ms] group-hover:[transition-timing-function:cubic-bezier(0.3,0.7,0.4,1.5)]",
        "group-active:duration-[34ms]"
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_styles__WEBPACK_IMPORTED_MODULE_2__.cn)("relative text-center", isDisabled && "opacity-50 pointer-events-none", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
            type: type,
            className: "group relative w-full p-0 rounded-xl border-none bg-[#477A1E] cursor-pointer outline-offset-1 transition-[filter] duration-[250ms]",
            onClick: onClick,
            disabled: isDisabled,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "absolute top-0 left-0 w-full h-full rounded-xl bg-[#477A1E]"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: (0,_utils_styles__WEBPACK_IMPORTED_MODULE_2__.cn)("relative flex justify-center items-center gap-4 self-stretch", "bg-[#70B237] rounded-xl will-change-transform", ...transitionClasses, frontClasses),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (0,_utils_styles__WEBPACK_IMPORTED_MODULE_2__.cn)("flex justify-center items-center gap-4", loading && "invisible"),
                            children: children
                        }),
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loaders_LoaderCircle_Loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            isLoading: true,
                            width: 18,
                            height: 18,
                            color: "white",
                            styles: {
                                position: "absolute"
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonPushable);


/***/ }),

/***/ 749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_Loaders_LoaderCircle_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9416);
/* harmony import */ var _utils_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4697);




const sizeClasses = {
    sm: "h-8 px-3 text-xs gap-1.5",
    md: "h-10 px-4 text-sm gap-2",
    lg: "h-12 px-6 text-base gap-2.5",
    xl: "h-16 px-10 text-xl gap-3"
};
const variantClasses = {
    default: "bg-[#8FCA5C] text-[#242C36] border-2 border-[#8FCA5C] hover:border-white",
    white: "bg-white text-[#242C36] border-2 border-[#e0e0e0] hover:border-[#c0c0c0]"
};
const iconSizes = {
    sm: 14,
    md: 16,
    lg: 18,
    xl: 22
};
const ButtonSecondary = (param)=>{
    let { size ="md" , variant ="default" , loading =false , disabled , text , onClick , type ="button" , className , style , icon , iconPosition ="left"  } = param;
    const isDisabled = disabled || loading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        style: style,
        className: (0,_utils_styles__WEBPACK_IMPORTED_MODULE_3__.cn)("inline-flex items-center justify-center rounded-lg font-poppins font-medium transition-all duration-150 cursor-pointer", "disabled:opacity-50 disabled:cursor-not-allowed", variantClasses[variant], sizeClasses[size], className),
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loaders_LoaderCircle_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            isLoading: true,
            width: iconSizes[size],
            height: iconSizes[size],
            color: variant === "white" ? "#242C36" : "white"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                icon && iconPosition === "left" && icon,
                text,
                icon && iconPosition === "right" && icon
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonSecondary);


/***/ }),

/***/ 7315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SaleIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const SaleIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "75",
        height: "75",
        viewBox: "0 0 75 75",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M26.0539 73.5H5C3.067 73.5 1.5 71.933 1.5 70L1.5 48.9461C1.5 48.0178 1.86875 47.1276 2.52513 46.4712L44.4001 4.59619C45.767 3.22935 47.983 3.22935 49.3499 4.59619L70.4038 25.6501C71.7706 27.017 71.7706 29.233 70.4038 30.5999L28.5288 72.4749C27.8724 73.1313 26.9822 73.5 26.0539 73.5ZM18.75 45.375C12.7653 45.375 7.875 50.2653 7.875 56.25C7.875 62.2347 12.7653 67.125 18.75 67.125C24.7347 67.125 29.625 62.2347 29.625 56.25C29.625 50.2653 24.7347 45.375 18.75 45.375Z",
                fill: "#AA69F4",
                stroke: "black",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M35.646 45.7209C35.0835 46.2833 34.4882 46.696 33.86 46.959C33.2318 47.222 32.6036 47.3097 31.9753 47.222C31.3544 47.127 30.7847 46.8348 30.266 46.3454L32.2602 44.3512C32.5743 44.6069 32.8921 44.7274 33.2135 44.7128C33.5276 44.6909 33.8198 44.5448 34.0901 44.2745C34.3677 43.9969 34.5247 43.7157 34.5612 43.4308C34.5905 43.1386 34.4919 42.8793 34.2654 42.6528C34.0755 42.4629 33.8527 42.3716 33.597 42.3789C33.3486 42.3789 33.0893 42.4337 32.819 42.5433C32.5561 42.6455 32.2018 42.8172 31.7562 43.0582C31.1061 43.4016 30.5472 43.6536 30.0797 43.8143C29.6122 43.975 29.1155 44.0188 28.5896 43.9458C28.0636 43.8727 27.5596 43.5952 27.0775 43.113C26.3616 42.3972 26.0621 41.579 26.179 40.6586C26.2885 39.7309 26.7597 38.8507 27.5924 38.0179C28.4398 37.1706 29.3273 36.6921 30.2551 36.5825C31.1755 36.4656 32.0155 36.7505 32.7752 37.4372L30.7481 39.4643C30.4852 39.2305 30.2003 39.1283 29.8935 39.1575C29.5794 39.1794 29.2908 39.3218 29.0278 39.5848C28.8014 39.8113 28.6809 40.056 28.6663 40.3189C28.6443 40.5746 28.7466 40.8157 28.9731 41.0421C29.2214 41.2905 29.5319 41.3672 29.9044 41.2722C30.277 41.1773 30.792 40.9618 31.4494 40.6257C32.1141 40.297 32.6766 40.056 33.1368 39.9026C33.6043 39.7419 34.0974 39.6944 34.616 39.7601C35.1347 39.8259 35.6241 40.0888 36.0843 40.549C36.5226 40.9873 36.8075 41.4987 36.939 42.0831C37.0778 42.6601 37.0412 43.2664 36.8294 43.902C36.6176 44.5375 36.2231 45.1438 35.646 45.7209Z",
                fill: "#EBDA45"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M42.9571 35.539L40.0863 38.4098L40.9848 40.2287L39.0234 42.1901L34.1146 31.7149L36.2841 29.5454L46.7592 34.4543L44.776 36.4375L42.9571 35.539ZM41.0286 34.5748L37.2593 32.7121L39.133 36.4704L41.0286 34.5748Z",
                fill: "#EBDA45"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M48.0336 30.2872L50.488 27.8327L51.9344 29.2791L47.6063 33.6072L39.9143 25.9152L41.788 24.0415L48.0336 30.2872Z",
                fill: "#EBDA45"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M48.5109 20.3209L50.0668 21.8768L52.5761 19.3676L54.0224 20.814L51.5132 23.3232L53.2006 25.0106L56.0385 22.1726L57.5397 23.6738L52.8281 28.3854L45.1361 20.6934L49.8477 15.9818L51.3488 17.483L48.5109 20.3209Z",
                fill: "#EBDA45"
            })
        ]
    });


/***/ }),

/***/ 985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ welcome; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/MarketingPricing/pricing-data.json
var pricing_data_namespaceObject = JSON.parse('[{"tier":"Noob","price":"Free","cta":"Let\'s Go!","features":[[{"text":"5 free skin generations","bold":true}],[],[]]},{"tier":"Hobbyist","price":"$2.49","sale":false,"cta":"Let\'s Go!","features":[[{"text":"5 free skin generations","bold":true}],[{"text":"50 additional skin generations","bold":true},{"text":"($0.05/generation)"}],[{"text":"Access to new and improved skin generation models."}]]},{"tier":"Gamer","highlight":true,"price":"$4.99","cta":"Let\'s Go!","features":[[{"text":"5 free skin generations","bold":true}],[{"text":"125 additional skin generations","bold":true},{"text":"($0.04/generation)"}],[{"text":"Access to new and improved skin generation models."}]]},{"tier":"Pro","price":"$9.99","cta":"Let\'s Go!","features":[[{"text":"5 free skin generations","bold":true}],[{"text":"333 additional skin generations","bold":true},{"text":"($0.03/generation)"}],[{"text":"Access to new and improved skin generation models."}]]}]');
// EXTERNAL MODULE: ./components/MarketingPricing/pricing.module.scss
var pricing_module = __webpack_require__(2823);
var pricing_module_default = /*#__PURE__*/__webpack_require__.n(pricing_module);
// EXTERNAL MODULE: ./components/icons/sale.tsx
var sale = __webpack_require__(7315);
// EXTERNAL MODULE: ./components/buttons/ButtonSecondary/ButtonSecondary.tsx
var ButtonSecondary = __webpack_require__(749);
;// CONCATENATED MODULE: ./components/MarketingPricing/MarketingPricing.jsx







function MarketingPricing(_props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (pricing_module_default()).columns,
        children: pricing_data_namespaceObject.map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: data.highlight ? "".concat((pricing_module_default()).column, " ").concat((pricing_module_default()).highlight) : (pricing_module_default()).column,
                children: [
                    data.sale && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (pricing_module_default()).sale,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sale/* SaleIcon */.r, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (pricing_module_default()).main,
                        children: data.tier
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (pricing_module_default()).secondary,
                        children: data.price
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/login",
                        className: (pricing_module_default()).cta,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                            size: "lg",
                            text: data.cta
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (pricing_module_default()).features,
                        children: data.features.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (pricing_module_default()).feature,
                                        children: feature.map((f, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: f.bold ? (pricing_module_default()).bold : (pricing_module_default()).body,
                                                    children: [
                                                        f.text,
                                                        " "
                                                    ]
                                                })
                                            }, i))
                                    }),
                                    index < data.features.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (pricing_module_default()).divider
                                    })
                                ]
                            }, index))
                    })
                ]
            }, data.tier))
    });
}

;// CONCATENATED MODULE: ./components/MarketingIcons/ChevronRight.jsx

function ChevronRight() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 40 40",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15 10L25 20L15 30",
            stroke: "#b4b4b4",
            strokeWidth: "4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}

// EXTERNAL MODULE: ./components/MarketingFaq/faq.module.scss
var faq_module = __webpack_require__(1304);
var faq_module_default = /*#__PURE__*/__webpack_require__.n(faq_module);
;// CONCATENATED MODULE: ./components/MarketingFaq/MarketingFaq.jsx




function MarketingFaq() {
    const [visibleQuestions, setVisibleQuestions] = (0,react.useState)([
        false,
        false,
        false,
        false
    ]);
    function toggleQuestion(index) {
        setVisibleQuestions((prev)=>{
            const copy = [
                ...prev
            ];
            copy[index] = !copy[index];
            return copy;
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((faq_module_default()).question, " ").concat(visibleQuestions[0] ? (faq_module_default()).visible : ""),
                onClick: ()=>toggleQuestion(0),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (faq_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "main",
                                children: "Is SkinGenerator.io associated with Microsoft or Mojang?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (faq_module_default()).icon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (faq_module_default()).answer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "secondary",
                            children: "No.  SkinGenerator.io is not an official Minecraft product, nor is it approved by or associated with Mojang or Microsoft."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((faq_module_default()).question, " ").concat(visibleQuestions[1] ? (faq_module_default()).visible : ""),
                onClick: ()=>toggleQuestion(1),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (faq_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "main",
                                children: "How does it work?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (faq_module_default()).icon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (faq_module_default()).answer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "secondary",
                            children: "The SkinGenerator starts with the latest generative art models, and then finetune our own models to generate usable in-game skins.  You provide a text prompt of what you've imagined, and we take care of the rest!"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((faq_module_default()).question, " ").concat(visibleQuestions[2] ? (faq_module_default()).visible : ""),
                onClick: ()=>toggleQuestion(2),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (faq_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "main",
                                children: "How do I save and use my skins?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (faq_module_default()).icon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (faq_module_default()).answer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "secondary",
                            children: "There is a button to download the currently selected skin.  You can then use the downloaded skin file in game."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((faq_module_default()).question, " ").concat(visibleQuestions[3] ? (faq_module_default()).visible : ""),
                onClick: ()=>toggleQuestion(3),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (faq_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "main",
                                children: "Why does my Minecraft skin look so weird?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (faq_module_default()).icon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (faq_module_default()).answer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "secondary",
                            children: 'You may not have given the generator enough information in your text prompt. Try being more specific: use descriptive language and more than single-word prompts. For example, instead of writing "snowman", you could try "snowman with a top hat and red scarf".'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((faq_module_default()).question, " ").concat(visibleQuestions[4] ? (faq_module_default()).visible : ""),
                onClick: ()=>toggleQuestion(4),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (faq_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "main",
                                children: "Are there other games available other than Minecraft?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (faq_module_default()).icon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (faq_module_default()).answer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "secondary",
                            children: "Not yet, but we'll be adding more in the future!"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/jsonp/index.js
var jsonp = __webpack_require__(365);
var jsonp_default = /*#__PURE__*/__webpack_require__.n(jsonp);
// EXTERNAL MODULE: ./components/MarketingContact/contact.module.scss
var contact_module = __webpack_require__(9129);
var contact_module_default = /*#__PURE__*/__webpack_require__.n(contact_module);
;// CONCATENATED MODULE: ./components/MarketingContact/MarketingContact.jsx





const mailchimpKey = "ec55ae85b9f7a00e7e633e319";
function MarketingContact(_props) {
    const [fname, setFname] = (0,react.useState)("");
    const [email, setEmail] = (0,react.useState)("");
    const [error, setError] = (0,react.useState)("");
    const [success, setSuccess] = (0,react.useState)("");
    function handleSubmit(event) {
        event.preventDefault();
        if (!fname || !email) {
            setError("Please fill out all fields");
            return;
        }
        const mailchimpUrl = "https://skingenerator.us21.list-manage.com/subscribe/post-json?u=".concat(mailchimpKey, "&amp;id=d4c48972af&amp;f_id=00b3e4e6f0");
        // @params url: string, opts?: {}, callback: () => void
        jsonp_default()("".concat(mailchimpUrl, "&EMAIL=").concat(email, "&NAME=").concat(fname), {
            param: "c"
        }, (err, data)=>{
            const { msg  } = data;
            if (err) {
                setError(err);
                return;
            }
            setSuccess(msg);
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (contact_module_default()).row,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (contact_module_default()).left,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "main",
                        children: "Subscribe for exclusive offers and updates"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "secondary text-center",
                        children: "We'll keep you up to date on new developments, including early access to new features and models."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (contact_module_default()).envelope,
                        src: "/images/marketing/envelope.png",
                        alt: "Image of an envelope"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (contact_module_default()).right,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: (contact_module_default()).contactForm,
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "fname",
                            children: "Name:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "name",
                            name: "name",
                            type: "text",
                            autoComplete: "given-name",
                            value: fname,
                            required: true,
                            onChange: (event)=>setFname(event.target.value)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "email",
                            children: "Email:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "email",
                            name: "email",
                            type: "email",
                            autoComplete: "email",
                            value: email,
                            required: true,
                            onChange: (event)=>setEmail(event.target.value)
                        }),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (contact_module_default()).error,
                            children: error
                        }),
                        success && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (contact_module_default()).success,
                            children: success
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                            type: "submit",
                            text: "Subscribe",
                            className: "w-full mt-4",
                            size: "xl"
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/MarketingPreview/preview.module.scss
var preview_module = __webpack_require__(9035);
var preview_module_default = /*#__PURE__*/__webpack_require__.n(preview_module);
;// CONCATENATED MODULE: ./components/MarketingPreview/MarketingPreview.jsx



const MarketingPreview_images = [
    "preview_1.png",
    "preview_2.png",
    "preview_3.png",
    "preview_4.png",
    "preview_5.png"
];
function MarketingPreview() {
    const [index, setIndex] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        const intervalId = setInterval(()=>{
            setIndex((index + 1) % MarketingPreview_images.length);
        }, 3000);
        return ()=>clearInterval(intervalId);
    }, [
        index
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (preview_module_default()).preview,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            className: (preview_module_default()).image,
            src: "/images/marketing/" + MarketingPreview_images[index],
            alt: "Preview of a Minecraft skin"
        })
    });
}

// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(3944);
// EXTERNAL MODULE: ./components/buttons/ButtonPushable/ButtonPushable.tsx
var ButtonPushable = __webpack_require__(7272);
;// CONCATENATED MODULE: ./pages/welcome/index.jsx









const Welcome = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "wrapper marketing",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "main",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "main",
                        children: "Minecraft Skin Generator"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "menu",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "menu-text",
                                href: "#pricing",
                                children: "Plans"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "menu-text",
                                href: "#faq",
                                children: "FAQ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "menu-text",
                                href: "#about",
                                children: "About"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "hero",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingPreview, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tagline",
                                    children: "Create custom skins from a text prompt"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: "cta",
                                    href: "/login",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPushable/* default */.Z, {
                                        size: "lg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-poppins text-4xl",
                                            children: "Generate Skins Now!"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                id: "pricing",
                className: "pricing",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "main",
                        children: "Plans"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingPricing, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                id: "faq",
                className: "faq",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "main",
                        children: "FAQ"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingFaq, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                id: "about",
                className: "about",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "main",
                        children: "About"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "secondary",
                        children: "The Minecraft Skin Generator uses custom generative models to create skins for video games. With a simple text prompt you can create characters quickly and easily. You're limited only by your imagination!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                id: "contact",
                className: "contact",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingContact, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                id: "footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                    hideSocialIcons: false,
                    hideBackground: true
                })
            })
        ]
    });
};
/* harmony default export */ var welcome = (Welcome);


/***/ }),

/***/ 3642:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__vcVmy","hideBackground":"Footer_hideBackground__S0no7","divider":"Footer_divider__nrTRf","main":"Footer_main__wRzjb","signature":"Footer_signature__yaisX"};

/***/ }),

/***/ 3856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__E52sw","primary":"Loader_primary__enB1K","loader":"Loader_loader__PhD0y","rotate":"Loader_rotate__niAw_","loaderText":"Loader_loaderText__g7nNR"};

/***/ }),

/***/ 9129:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"row":"contact_row__WQrUg","left":"contact_left__QAaN3","right":"contact_right__tGqdy","contactForm":"contact_contactForm__KpA6q","error":"contact_error__NuBOF","success":"contact_success__7LVnG","envelope":"contact_envelope__OVcBq"};

/***/ }),

/***/ 1304:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"question":"faq_question__Aaybn","answer":"faq_answer__9LdXU","visible":"faq_visible__6sT6H","icon":"faq_icon__n9D_R","content":"faq_content__ke4u_"};

/***/ }),

/***/ 9035:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"preview":"preview_preview__qzBEu","image":"preview_image__gFpV0"};

/***/ }),

/***/ 2823:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"columns":"pricing_columns__JUtPv","column":"pricing_column__iafIU","highlight":"pricing_highlight__bsyAI","cta":"pricing_cta__DskVN","main":"pricing_main__KFUik","secondary":"pricing_secondary__7LXrO","bold":"pricing_bold__cyKly","body":"pricing_body__902Am","features":"pricing_features__Snoa_","feature":"pricing_feature__meWUb","divider":"pricing_divider__rlkae","sale":"pricing_sale__D6pcn"};

/***/ }),

/***/ 4103:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"default":"Brand_default__jriME","white":"Brand_white__MXPYV Brand_default__jriME","large":"Brand_large__c9hmX Brand_default__jriME"};

/***/ })

}]);